import React from 'react';
import { getMessage } from 'util/locale';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { get } from 'lodash';

// components
import ScriptName from 'common/ScriptName';
import Explainer from 'planting-plan-form/Explainer';
import HtmlText from 'html-text/HtmlText';

const baseString = 'vra-default-script-name';
const classString = classNames({
  [`${baseString}`]: true,
  'vra-planting-plan-form__fieldset': true
});

const DefaultScriptName = ({
  disabled,
  isVisible,
  onChange,
  plantingPlanParams,
  validationResult
}) => {
  const { defaultScriptName, scriptName } = plantingPlanParams;
  const isInvalid = get(validationResult, 'isInvalid', false);
  let displayScriptName;
  // if there is a validationResult, show the script name as entered (possibly empty string)
  if (isInvalid) {
    displayScriptName = scriptName;
  } else {
    // if there is no validationResult and no script name, use the default script name
    displayScriptName = scriptName || defaultScriptName;
  }

  return isVisible ? (
    <section className={classString}>
      <Explainer>
        <HtmlText messageKey='text__manual-default-script-name' />
      </Explainer>
      <div className='vra-planting-plan-form__inputs-wrapper'>
        <ScriptName
          dataTestId={baseString}
          disabled={disabled}
          displayScriptName={displayScriptName}
          forceUpdateKey={displayScriptName}
          label={getMessage('title-text__default-script-name')}
          onChange={onChange}
          validationResult={validationResult}
        />
      </div>
    </section>
  ) : null;
};
DefaultScriptName.propTypes = {
  disabled: propTypes.bool,
  isVisible: propTypes.bool.isRequired,
  onChange: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object.isRequired,
  validationResult: propTypes.object
};
export default DefaultScriptName;
